export const defaultRoutes = {
  default: { name: 'Main' }
}

const routes = [
  {
    path: '',
    component: () => import('layouts/Default'),
    children: [
      {
        path: '',
        name: 'Main',
        component: () => import('pages/Main')
      },
      {
        path: '/return/:id/',
        name: 'GenerateReturnVoucher',
        component: () => import('pages/GenerateReturnVoucher')
      },
      {
        path: '/expired',
        name: 'ExpiredLink',
        component: () => import('pages/ExpiredLink')
      }
    ]
  }
  // { path: '/', redirect: defaultRoutes.default } // if no
]

if (process.env.STAGE === 'development') {
  routes.push({
    path: '/test',
    name: 'TestGenerateReturnVoucher',
    component: () => import('pages/test/TestGenerateReturnVoucher')
  })
}

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/Error404')
  })
}

export default routes
